import ConfirmModal from '@components/modal/ConfirmModal';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { AdminUser } from 'src/types/shared/AdminUser';
import useDeleteAdmin from './hooks/useDeleteAdmin';

const DeleteAdminModal: React.FC<DeleteAdminProps> = ({ user, closeModal }) => {
    const { deleteUser, isPosting, error, deleteSuccess } = useDeleteAdmin(user.id);
    const prevSuccess = usePrevious(deleteSuccess);

    useEffect(() => {
        if (!prevSuccess && deleteSuccess) closeModal();
    }, [deleteSuccess, prevSuccess, closeModal]);

    return (
        <ConfirmModal
            title="Delete admin"
            description={`Are you sure you want to delete '${user.firstName} ${user.lastName}'?`}
            closeModal={closeModal}
            handleSubmit={deleteUser}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteAdminProps {
    user: AdminUser;
    closeModal: () => void;
}

export default DeleteAdminModal;
